import { MapPinIcon, ShieldCheckIcon } from '@heroicons/react/24/solid';

export default function SupportedStatesPage() {
    const primaryStates = ["Lagos", "Ogun", "Oyo"];
    const otherStates = ["Osun", "Ekiti", "Ondo", "Kwara", "Delta", "Edo"];

    return (
        <div className="bg-white dark:bg-gray-900">
            <header className="bg-gray-50 dark:bg-gray-800 py-16 text-center">
                <div className="container mx-auto px-4">
                    <MapPinIcon className="w-16 h-16 mx-auto text-orange-500" />
                    <h1 className="mt-4 text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white">Supported States & Pickup Policy</h1>
                    <p className="mt-4 text-xl text-gray-500 dark:text-gray-400 max-w-3xl mx-auto">
                        Our current operational focus and our policy on item collection.
                    </p>
                </div>
            </header>

            <main className="container mx-auto px-4 py-20">
                <div className="max-w-4xl mx-auto">
                    <div className="bg-yellow-50 dark:bg-yellow-900/50 border-l-4 border-yellow-500 text-yellow-800 dark:text-yellow-200 p-6 rounded-r-lg mb-12">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" />
                            </div>
                            <div className="ml-3">
                                <h3 className="text-lg font-bold">Mandatory In-Person Pickup Policy</h3>
                                <div className="mt-2 text-base">
                                    <p>For security and verification purposes, all gifted items **must be collected in person** by the recipient from our designated center in Lagos. Please ensure you can travel to Lagos to receive your item before starting a campaign.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Primary Support Zones</h2>
                        <p className="mt-2 text-gray-600 dark:text-gray-400">We have active partnerships and outreach programs in the following states, making it easier for recipients to travel for pickup:</p>
                        <div className="mt-4 flex flex-wrap gap-4">
                            {primaryStates.map(state => (
                                <span key={state} className="bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-200 text-lg font-semibold px-4 py-2 rounded-full">{state}</span>
                            ))}
                        </div>
                    </div>

                    <div className="mt-12">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">All Other Nigerian States</h2>
                        <p className="mt-2 text-gray-600 dark:text-gray-400">While we accept applications from all states in Nigeria, please be reminded of our mandatory in-person pickup policy in Lagos. We are working hard to establish more pickup centers in the future.</p>
                         <div className="mt-4 flex flex-wrap gap-4">
                            {otherStates.map(state => (
                                <span key={state} className="bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200 text-md font-medium px-3 py-1 rounded-full">{state}</span>
                            ))}
                             <span className="text-md font-medium px-3 py-1">... and more</span>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}